import { selectCurrentRoom } from "@/context/features/room/roomSlice";
import { useGetWaitingUsersQuery } from "@/graphql/generated";
import { shallowEqual, useSelector } from "react-redux";
import SortablePatient from "./patients-item";
import { useTranslation } from "react-i18next";
import PatientItemPlaceholder from "./patient-item-placeholder";
import { useEffect } from "react";
import { UserRoundSearch } from "lucide-react";
type Props = {
  onRefetchReady?: (refetch: () => void) => void;
  selectPatient: (data: {
    pid: string;
    name: string;
    visitTime: string;
    isPending: boolean;
  }) => void;
};

export default function PatientWaitingList({
  onRefetchReady,
  selectPatient,
}: Props) {
  const { roomData } = useSelector(selectCurrentRoom, shallowEqual);
  const { t } = useTranslation();
  const { data, loading, error, refetch } = useGetWaitingUsersQuery({
    variables: { roomName: roomData?.name ?? "" },
    fetchPolicy: "cache-first",
    skip: !roomData?.name,
  });

  useEffect(() => {
    onRefetchReady?.(refetch);
  }, [refetch, onRefetchReady]);

  if (loading) {
    return (
      <div className="flex flex-col gap-2 ">
        <h6 className="text-primary font-semibold m-1">
          {t("waiting_patient_list")}
        </h6>
        <PatientItemPlaceholder />
        <PatientItemPlaceholder />
        <PatientItemPlaceholder />
        <PatientItemPlaceholder />
        <PatientItemPlaceholder />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-2 text-sm text-red-500">{t("Failed to fetch")}</div>
    );
  }

  return (
    <div className="overflow-y-auto overflow-x-hidden px-1 pt-3 h-full flex flex-col gap-1 pb-10">
      <h6 className="text-foreground font-semibold ps-1">
        {t("waiting_patient_list")}
      </h6>

      {data?.room?.waitingUsers?.length ? (
        data.room.waitingUsers.map((patient) => (
          <SortablePatient
            key={patient.id}
            patient={patient}
            locked
            isWaiting
            action_call_back={() => console.log("")}
            selectPatient={selectPatient}
          />
        ))
      ) : (
        <div className="flex flex-col items-center gap-4 py-12">
          <UserRoundSearch
            className="size-12 text-muted-foreground/40"
            strokeWidth={1.75}
          />
          <p className="text-base text-muted-foreground text-center">
            {t("patient_not_found")}
          </p>
        </div>
      )}
    </div>
  );
}
